import React from 'react';
import { Text } from 'Common/components/Atoms/Text';
import { useTheme } from '@mui/material/styles';

interface Props {
  children: React.ReactNode;
}

export function FooterBullet({ children }: Props): JSX.Element {
  const theme = useTheme();
  return (
    <Text pt={1} variant="body1" fontWeight={theme.typography.fontWeightLight}>
      {children}
    </Text>
  );
}
